import {
  Card,
  Flex,
  FilterProvider,
  useScreenResolution,
  ColorProvider,
  ModalProvider,
  UpgradeSubscriptionModalType,
} from 'dash-ui';

import PortfolioViewsHeader from 'pages/Dashboard/components/PortfolioViewsWidget/components/PortfolioViewsHeader/PortfolioViewsHeader';
import PortfolioViewsChart from 'pages/Dashboard/components/PortfolioViewsWidget/components/PortfolioViewsChart/PortfolioViewsChart';
import UpgradeSubscriptionModal from 'common/components/UpgradeSubscriptionModal/UpgradeSubscriptionModal';
import { SubscriptionChangeConfirmationModal } from 'pages/ProfilePage/components/ProfileBilling/components';

function PortfolioViewsWidget() {
  const {
    devices: { isMobile },
  } = useScreenResolution();
  return (
    <ModalProvider>
      <>
        <FilterProvider>
          <ColorProvider>
            <Card p={4} w="100%">
              <Flex
                w="100%"
                minHeight={272}
                flexDirection="column"
                overflow={isMobile ? 'scroll' : 'unset'}
              >
                <PortfolioViewsHeader />
                <PortfolioViewsChart />
              </Flex>
            </Card>
          </ColorProvider>
        </FilterProvider>
        <SubscriptionChangeConfirmationModal />
        <UpgradeSubscriptionModal
          type={UpgradeSubscriptionModalType.PORTFOLIO}
        />
      </>
    </ModalProvider>
  );
}

export default PortfolioViewsWidget;
